<!-- 特典を探す 中カテゴリ分類 -->
<template>
  <div class="crly-a-common-search-keyword-middle-category-btn">
    <button @click="clickBtn" :class="{ active: category === active }">
      {{ $t(`common.middleCategory.cat${category}`) }}
    </button>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordMiddleCategoryBtn",
  props: {
    /**
     * カテゴリ
     */
    category: {
      type: Number,
      default: null
    },
    /**
     * 選択中のカテゴリ
     */
    active: {
      type: Number,
      default: null
    }
  },
  methods: {
    /**
     * カテゴリクリックイベント
     */
    clickBtn() {
      this.$emit("clickMidCatBtn", this.category);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/middleCategoryBtn.scss";
</style>